import {buildContext} from '@coveo/headless';
import {useContext} from 'react';
import {AppContext} from './engine';

export function Context() {
  const {engine} = useContext(AppContext);
  const ctx = buildContext(engine!);

	ctx.set({});

  return null;
}
